//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import Multiselect from "vue-multiselect";
import { areaData } from "../../util/areaDataNew";
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast} from 'vant';
import { toolRex } from '@/util/base';
export default {
    components:{
    Header,
    Footer,
    Multiselect
 },
        name: 'Home',
        data(){
            return{
                screenWeight: 0,        
                screenHeight: 0,        
                index: 1,               
                curIndex: 1,            
                startTime: 0,           
                endTime: 0,             
                nowTop: 0,             
                pageNum: 0,             
                main: Object,
                obj: Object
            }
        },
        mounted(){
            this.screenWeight = document.documentElement.clientWidth;
            this.screenHeight = document.documentElement.clientHeight;
            this.main = document.getElementById("main");
            this.obj = document.getElementsByTagName("div");
            for (let i = 0; i < this.obj.length; i++) {
                if (this.obj[i].className == 'page') {
                    this.obj[i].style.height = this.screenHeight + "px";
                }
            }
            this.pageNum = document.querySelectorAll(".page").length;     
            if ((navigator.userAgent.toLowerCase().indexOf("firefox") != -1)) {
                document.addEventListener("DOMMouseScroll", this.scrollFun, false);
            } else if (document.addEventListener) {
                document.addEventListener("mousewheel", this.scrollFun, false);
            } else if (document.attachEvent) {
                document.attachEvent("onmousewheel", this.scrollFun);
            } else {
                document.onmousewheel = this.scrollFun;
            }
        },
        methods:{
            toPage(){

            },
            scroll(event) {
                let y = event.target.scrollTop
                if(y <= 650 - 40){
                    this.curIndex = 1
                    return
                }
                if(y <= 1300 - 40 && y>=650){
                    this.curIndex = 2
                    return
                }
                if(y <= 1950 - 40 && y>=1300){
                    this.curIndex = 3
                    return
                }
                if(y <= 2600 - 40 && y>=1950){
                    this.curIndex = 4
                    return
                }
                if(y <= 3250 - 40 && y>=2600){
                    this.curIndex = 5
                    return
                }
                if(y <= 3900 - 40 && y>=3250){
                    this.curIndex = 6
                    return
                }
                if(y <= 4550 - 40 && y>=3900){
                    this.curIndex = 7
                    return
                }
                if(y <= 5200 - 40 && y>=4550){
                    this.curIndex = 8
                    return
                }
                if(y <= 5850 - 40 && y>=5200){
                    this.curIndex = 9
                    return
                }
                if(y <= 6500 - 40 && y>=5850){
                    this.curIndex = 10
                    return
                }
                if(y <= 7150 - 40 && y>=6500){
                    this.curIndex = 11
                    return
                }
                if(y <= 7800 - 40 && y>=7150){
                    this.curIndex = 12
                    return
                }
            },
        }
    }



// WEBPACK FOOTER //
// ./src/pages/full/full.vue